import countries from "../../../../core/consts/countries";

function extractPhoneCountryCode(phone: string): [string, string] {
  let bestMatch: [string, string] = ["", ""];
  let bestLength = 0;

  for (let i = 0; i < countries.length; i++) {
    const codes = countries[i].countryCallingCodes;
    for (let j = 0; j < codes.length; j++) {
      const code = codes[j].replace(/\s/g, "");
      if (phone.indexOf(code) === 0 && code.length > bestLength) {
        bestMatch = [code, phone.slice(code.length)];
        bestLength = code.length;
      }
    }
  }
  return bestMatch;
}
export default extractPhoneCountryCode;
